module.exports = __webpack_public_path__ + "img/user.7e9fabdb.png";